import { Mesh, MeshStandardMaterial, type Object3D } from 'three';

/** Subtle powder-coat grain and oxidized metal, anchored to the actual surface. */
export function applyHullFinish(root: Object3D, weathered: boolean) {
  const done = new Set<MeshStandardMaterial>();
  root.traverse(object => {
    if (!(object instanceof Mesh) || !(object.material instanceof MeshStandardMaterial)) return;
    const material = object.material;
    if (done.has(material) || !['anodized', 'worn-alloy', 'heat-shield', 'oxide'].includes(material.name)) return;
    done.add(material);
    material.customProgramCacheKey = () => weathered ? 'oxidized-hull-1' : 'cabin-powdercoat-1';
    material.onBeforeCompile = shader => {
      shader.vertexShader = shader.vertexShader.replace('#include <common>', '#include <common>\nvarying vec3 vHullPoint;');
      shader.vertexShader = shader.vertexShader.replace('#include <begin_vertex>', '#include <begin_vertex>\nvHullPoint = position;');
      shader.fragmentShader = shader.fragmentShader.replace('#include <common>', `#include <common>
        varying vec3 vHullPoint;
        float hullHash(vec3 p) {
          p = fract(p * .1031); p += dot(p, p.yzx + 33.33);
          return fract((p.x + p.y) * p.z);
        }
        float hullNoise(vec3 p) {
          vec3 i = floor(p), f = fract(p); f = f * f * (3.0 - 2.0 * f);
          return mix(mix(mix(hullHash(i), hullHash(i + vec3(1,0,0)), f.x),
                         mix(hullHash(i + vec3(0,1,0)), hullHash(i + vec3(1,1,0)), f.x), f.y),
                     mix(mix(hullHash(i + vec3(0,0,1)), hullHash(i + vec3(1,0,1)), f.x),
                         mix(hullHash(i + vec3(0,1,1)), hullHash(i + vec3(1,1,1)), f.x), f.y), f.z);
        }`);
      // Fade subpixel grain to avoid sparkling as the ship moves past the metal.
      shader.fragmentShader = shader.fragmentShader.replace('#include <map_fragment>', `#include <map_fragment>
        float grainFade = 1.0 - smoothstep(.006, .04, length(fwidth(vHullPoint)));
        float grain = (hullHash(floor(vHullPoint * 230.0)) - .5) * grainFade;
        float patina = hullNoise(vHullPoint * 5.0) * .6 + hullNoise(vHullPoint * 29.0) * .4;
        diffuseColor.rgb *= ${weathered ? '(.72 + patina * .38 + grain * .13)' : '(.96 + grain * .08)'};`);
      shader.fragmentShader = shader.fragmentShader.replace('#include <roughnessmap_fragment>', `#include <roughnessmap_fragment>
        roughnessFactor = clamp(roughnessFactor + grain * .14 ${weathered ? '+ (patina - .5) * .18' : ''}, .25, .95);`);
    };
    material.needsUpdate = true;
  });
}
